// Base prices for gold and silver (fallback values in EUR/g)
export const BASE_PRICES = {
  GOLD: 65.78, // EUR per gram for gold
  SILVER: 0.92, // EUR per gram for silver
};

// Gold purity definitions with labels and multipliers
// IMPORTANT: Keys must match exactly with database values
export const GOLD_PURITIES = {
  "24 KT": { label: "24 KT", multiplier: 1.0 },
  "22 KT": { label: "22 KT", multiplier: 0.916 },
  "20 KT": { label: "20 KT", multiplier: 0.833 },
  "18 KT": { label: "18 KT", multiplier: 0.75 },
  "14 KT": { label: "14 KT", multiplier: 0.585 },
  "9 KT": { label: "9 KT", multiplier: 0.375 }
} as const;

// Silver purity definitions with labels and multipliers
export const SILVER_PURITIES = {
  "PURO": { label: "999‰", multiplier: 1.0 }, // 999‰ or 99.9% pure
  "925": { label: "925‰", multiplier: 0.925 }, // Sterling silver (92.5%)
  "800": { label: "800‰", multiplier: 0.8 } // 80% pure
} as const;

export const PURITY_MULTIPLIERS = {
  ORO: Object.fromEntries(
    Object.entries(GOLD_PURITIES).map(([key, value]) => [key, value.multiplier])
  ) as Record<keyof typeof GOLD_PURITIES, number>,
  ARGENTO: Object.fromEntries(
    Object.entries(SILVER_PURITIES).map(([key, value]) => [key, value.multiplier])
  ) as Record<keyof typeof SILVER_PURITIES, number>,
};

// Available units for silver
export const SILVER_UNITS = ["g", "kg"] as const;

// Default selections with updated format
export const DEFAULT_GOLD_PURITY = "24 KT";
export const DEFAULT_SILVER_PURITY = "PURO";
export const DEFAULT_SILVER_UNIT = "g";

// Unit conversion factors
export const UNIT_CONVERSION = {
  "g": 1.0, // grams to grams
  "kg": 1000.0 // grams to kilograms
} as const;

// Export types for TypeScript
export type GoldPurityKey = keyof typeof GOLD_PURITIES;
export type SilverPurityKey = keyof typeof SILVER_PURITIES;
export type UnitType = keyof typeof UNIT_CONVERSION;
